<div class="cotent-columns">
  <div class="column-left">
    <div class="box-itinerary">
      <div class="box-title">
        <p></p>
      </div>
      <div class="box-flight" *ngFor="let flight of [].constructor(2)">
        <div class="content">
          <p class="date"></p>
          <div class="content-city">
            <span class="city"></span> <i aria-hidden="true" class="icon-arrow-forw"></i>
            <span class="city"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="box-itinerary arrival">
      <div class="box-title">
      </div>
      <div class="box-flight" *ngFor="let flight of [].constructor(2)">
        <div class="content">
          <p class="date"></p>
          <div class="content-city">
            <span class="city"></span> <i aria-hidden="true" class="icon-arrow-forw"></i>
            <span class="city"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="column-right">
    <div class="content-seat-map">
      <div class="header">
        <div class="button-left"></div>
        <div class="content-center">
          <div class="info-airline">
            <span class="image"></span>
            <span class="text"></span>
          </div>
          <div class="info-flight">
          </div>
        </div>
        <div class="button-right"></div>
      </div>
      <div class="content-map">
        <div class="map">
          <div class="box-indicators">
            <div class="box-indicator">
              <span></span>
            </div>
            <div class="box-indicator">
              <span></span>
            </div>
            <div class="box-indicator">
              <span></span>
            </div>
          </div>
          <app-seat-map-flight-placeholder></app-seat-map-flight-placeholder>
        </div>
        <div class="passengers">
          <div class="box-passengers">
            <div class="title"></div>
            <div class="passenger" *ngFor="let seat of [].constructor(4)">
              <div class=" name">
              </div>
              <span class="not-seat"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>